module.exports = __webpack_public_path__ + "img/3d.be9a6833.png";